import React, { useCallback, useState } from "react";
import Switch from "sushiweb/Switch";

const ToggleSwitch = ({
  handleChange,
  id,
  label,
  size,
  spacing,
  isActive,
  keyName,
  noMargin,
  extraParams,
  disabled = false,
  className = "semibold",
  changeOnState, //applicable when isActive is controlled via component state
}) => {
  const [val, setVal] = useState(isActive);

  const handleToggleChange = (flag) => {
    handleChange(keyName, flag, extraParams);
    !changeOnState && setVal(flag);
  };

  const getClassName = () => {
    if (changeOnState) {
      return isActive ? "active" : "inactive";
    } else {
      return val ? "active" : "inactive";
    }
  };

  return (
    <div className={`flex items-center ${noMargin ? "mb-0" : "mb-20"}`}>
      {label && (
        <span className={`switch-label mr-10 ${className}`}>
          {label + " :"}
        </span>
      )}
      <Switch
        readOnly={disabled}
        id={id}
        disabled={disabled}
        onToggle={(flag) => handleToggleChange(flag)}
        className={getClassName()}
        size={size}
        spacing={spacing}
        active={isActive}
        changeOnState={changeOnState}
      />
    </div>
  );
};

export default ToggleSwitch;
